/* eslint-disable no-new,no-unused-vars */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import ElementUI from 'element-ui';
import router from '@/router';
import i18n from '@/translation';
import FPS from '@fps/vue-toolkit';
import * as VueGoogleMaps from 'vue2-google-maps';
import Echo from '@/modules/laravel-echo/src';
import SocialSharing from 'vue-social-sharing';
import { VueMasonryPlugin } from 'vue-masonry';
// import { VueHammer } from 'vue2-hammer';
import filter from '@/filter';
import store from '@/store';
import App from '@/App';
import VueTruncate from 'vue-truncate-filter';

/* Add To Home Screen */
import '@/modules/addToHomeScreen/addtohomescreen.css';
import '@/modules/addToHomeScreen/addtohomescreen';

/* Add This */
import AddThis from '@/modules/addThis/addThis';

import 'vue-xeditable/src/editable/css/bootstrap.min.css'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/icon.css';
import 'element-ui/lib/theme-chalk/display.css';
import '@/style/index.scss';
import { LoaderPlugin } from 'vue-google-login';
import VueObserveVisibility from 'vue-observe-visibility';
import { overrideSave, overrideInit, getConfig } from '@/utils'
import moment from 'moment';
import '@/translation/moment/ps';
import '@/translation/moment/fa';
import ResponseInterceptor from '@/services/axios-interceptor';
import googleAnalytics, { page } from 'vue-analytics';
import MessageBox from 'element-ui/packages/message-box';
import Message from 'element-ui/packages/message';
import Dropdown from 'element-ui/lib/dropdown';
import VueLoadImage from '@/components/Core/VueLoadImage';
Vue.config.productionTip = false;

FPS.handleStateSave = overrideSave;
FPS.init = overrideInit;

// Initialize global vue object
Vue.fps = {}
// Configure http adapter
FPS.configureHttp(Vue)
Vue.appResponseInterceptor = new ResponseInterceptor(Vue.prototype.$http);

Vue.prototype.lazyLoadPackages = {};

Vue.use(FPS, {
  propagateState: true,
  localStorageStateKey: 'zood',
  router,
  excludedStates: ['temp', 'filters', 'config']
});

Vue.use(VueMasonryPlugin);
// Vue.use(VueHammer);
Vue.use(SocialSharing);
Vue.use(filter);

// Vue.use(ElementUI);
Vue.use(VueObserveVisibility);
Vue.use(VueTruncate);

Vue.component(ElementUI.Dialog.name, ElementUI.Dialog);
Vue.component(Dropdown.name, Dropdown);
Vue.component(ElementUI.DropdownMenu.name, ElementUI.DropdownMenu);
Vue.component(ElementUI.DropdownItem.name, ElementUI.DropdownItem);
Vue.component(ElementUI.Row.name, ElementUI.Row);
Vue.component(ElementUI.Col.name, ElementUI.Col);
Vue.component(ElementUI.Form.name, ElementUI.Form);
Vue.component(ElementUI.FormItem.name, ElementUI.FormItem);
Vue.component(ElementUI.Input.name, ElementUI.Input);
Vue.component(ElementUI.InputNumber.name, ElementUI.InputNumber);
Vue.component(ElementUI.Tabs.name, ElementUI.Tabs);
Vue.component(ElementUI.TabPane.name, ElementUI.TabPane);
Vue.component(ElementUI.ButtonGroup.name, ElementUI.ButtonGroup);
Vue.component(ElementUI.Button.name, ElementUI.Button);
Vue.component(ElementUI.Card.name, ElementUI.Card);
Vue.component(ElementUI.Option.name, ElementUI.Option);
Vue.component(ElementUI.Select.name, ElementUI.Select);
Vue.component(ElementUI.Breadcrumb.name, ElementUI.Breadcrumb);
Vue.component(ElementUI.BreadcrumbItem.name, ElementUI.BreadcrumbItem);
Vue.component(ElementUI.Upload.name, ElementUI.Upload);
Vue.component(ElementUI.Switch.name, ElementUI.Switch);
Vue.component(ElementUI.Carousel.name, ElementUI.Carousel);
Vue.component(ElementUI.CarouselItem.name, ElementUI.CarouselItem);
Vue.component(ElementUI.Menu.name, ElementUI.Menu);
Vue.component(ElementUI.MenuItem.name, ElementUI.MenuItem);
Vue.component(ElementUI.Progress.name, ElementUI.Progress);
Vue.component(ElementUI.Badge.name, ElementUI.Badge);
Vue.use(ElementUI.Loading.directive);
// Vue.prototype.$loading = Loading.service;
// Vue.prototype.$msgbox = MessageBox;
// Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
// Vue.prototype.$prompt = MessageBox.prompt;
// Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

Vue.component('vue-load-image', VueLoadImage);

const config = getConfig()

// Echo initialization
Vue.prototype.lazyLoadPackages.echo = {
  loaded: false,
  load: () => {
    if (!Vue.prototype.lazyLoadPackages.echo.loaded) {
      Vue.prototype.lazyLoadPackages.echo.loaded = true
      window.io = require('socket.io-client');
      Vue.use(Echo, {
        socketAppId: config.socketAppId,
        socketAppKey: config.socketAppKey,
        apiUrl: config.apiUrl,
      });
    }
  }
};

// AddThis initialization
Vue.prototype.lazyLoadPackages.addThis = {
  loaded: false,
  load: () => {
    if (!Vue.prototype.lazyLoadPackages.addThis.loaded) {
      Vue.prototype.lazyLoadPackages.addThis.loaded = true
      Vue.use(AddThis, {
        addThisPubId: config.addThisPubId,
      })
    }
  }
};

// Init google auth
Vue.prototype.lazyLoadPackages.googleOauth = {
  loaded: false,
  load: () => {
    if (!Vue.prototype.lazyLoadPackages.googleOauth.loaded) {
      Vue.prototype.lazyLoadPackages.googleOauth.loaded = true
      // Install
      if (config.googleClientId) {
        Vue.use(LoaderPlugin, { client_id: config.googleClientId });
      }
    }
  }
};

// Init google maps ( does async requests, no need to async load it )
if (config.googleMapsKey) {
  Vue.use(VueGoogleMaps, {
    load: {
      key: config.googleMapsKey,
      libraries: 'places,drawing,visualization',
    },
    autobindAllEvents: true,
  });
}

// Non critical, run after vue
setTimeout(() => {
  window.addToHomescreen({ lifespan: 30 });

  moment.locale('en');
  store.watch(state => state.locale, {
    immediate: true,
    handler: (locale) => { moment.locale(locale); },
  });

  // Init analytics ( does async requests, no need to async load it )
  if (config.gtmId) {
    Vue.use(googleAnalytics, {
      id: config.gtmId,
      checkDuplicatedScript: true,
    });

    router.afterEach((to, from) => {
      page({
        page: to.path,
        title: to.name,
        location: `${window.location.origin}/#${to.path}`,
      });
    });
  }

  if (window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches) {
    document.getElementsByTagName('body')[0].classList.add('is-pwa');
  }
})

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js